import React from 'react';
import { motion } from 'framer-motion';

const TermsPage = () => {
  return (
    <div className="bg-zinc-950 grid-background min-h-screen text-zinc-100 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="prose prose-invert prose-zinc max-w-none"
        >
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">Terms of Service</h1>
          <p className="text-zinc-400 mb-12">Terms governing access to and use of Doora services.<br/>Last Updated: April 7, 2026</p>

          <p>These Terms of Service govern access to and use of the services, software, website, and platform provided by PT Neuronworks Indonesia</p>
          <p>By accessing or using the Doora website or platform, you agree to these Terms and to comply with all applicable laws and regulations. If you do not agree with these Terms, you must not use the Doora services.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">1. Company Information</h2>
          <p>PT Neuronworks Indonesia</p>
          <p>Email: support@neuronworks.co.id</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">2. Description of Services</h2>
          <p>Doora provides software solutions and a cloud-based platform designed to support knowledge management, automation, and business process documentation.</p>
          <p>Services may include:</p>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Software applications and software-as-a-service platform access</li>
            <li>Application programming interfaces and integrations</li>
            <li>Documentation and support resources</li>
            <li>Related digital services and features</li>
          </ul>
          <p>Doora may modify, update, or improve the services at any time to enhance functionality, performance, or security.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">3. Use of Service</h2>
          <p>You agree to use Doora only for lawful purposes and in a way that does not:</p>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Violate applicable laws or regulations</li>
            <li>Infringe the rights of others</li>
            <li>Interfere with or disrupt the service or infrastructure</li>
            <li>Attempt unauthorized access to systems or data</li>
            <li>Transmit malicious software or harmful content</li>
          </ul>
          <p>Doora reserves the right to suspend or restrict access to the service if these Terms are violated.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">4. Accounts and Access</h2>
          <p>Some features of the Doora platform require user accounts. When creating an account, you agree to:</p>
          <ul className="list-disc pl-6 space-y-2 mb-4">
            <li>Provide accurate and complete information</li>
            <li>Maintain the confidentiality of your login credentials</li>
            <li>Notify Doora immediately of unauthorized access</li>
          </ul>
          <p>You are responsible for all activities that occur under your account. Doora may suspend or terminate accounts that violate these Terms or applicable laws.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">5. Intellectual Property</h2>
          <p>Unless otherwise stated, all content, software, and materials provided through the Doora platform are owned by Doora or its licensors and are protected by applicable intellectual property laws.</p>
          <p>This includes but is not limited to: Software code, Platform design, Trademarks and branding, and Documentation and materials.</p>
          <p>You may not copy, modify, distribute, reverse engineer, or exploit any part of the service except as permitted by applicable law or written agreement.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">6. Customer Data</h2>
          <p>Users retain ownership of the data and content they upload or create within the Doora platform.</p>
          <p>By using the service, you grant Doora the limited rights necessary to process and store such data solely for the purpose of operating and providing the service.</p>
          <p>Processing of personal data is governed by Doora's Privacy Policy and applicable data protection laws including the General Data Protection Regulation.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">7. Service Availability</h2>
          <p>Doora aims to maintain reliable service availability but does not guarantee uninterrupted or error-free operation.</p>
          <p>The service may be temporarily unavailable due to: Maintenance or updates, Infrastructure issues, Security incidents, or Events outside Doora's reasonable control.</p>
          <p>Doora will make reasonable efforts to restore services as quickly as possible.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">8. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, Doora shall not be liable for indirect, incidental, special, consequential, or punitive damages arising from or related to the use of the service. This includes, but is not limited to: Loss of profits, Loss of business opportunities, Loss of data, and Business interruption.</p>
          <p>Nothing in these Terms limits liability where such limitation is not permitted under applicable law.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">9. Third-Party Services</h2>
          <p>The Doora platform may integrate with or link to third-party services or external websites. Doora is not responsible for the content, security, or practices of third-party providers. Use of such services is subject to their respective terms and policies.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">10. Termination</h2>
          <p>Doora may suspend or terminate access to the service if: These Terms are violated, Required by law or regulation, or Necessary to protect the platform or other users.</p>
          <p>Users may stop using the service at any time.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">11. Changes to These Terms</h2>
          <p>Doora may update these Terms periodically to reflect changes in services, legal requirements, or operational practices. Updated Terms will be published on the Doora website with the revised effective date. Continued use of the service after such changes constitutes acceptance of the updated Terms.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">12. Governing Law</h2>
          <p>These Terms are governed by the laws of Singapore, without regard to conflict of law principles. Where legally permitted, the exclusive place of jurisdiction shall be Singapore.</p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">13. Contact</h2>
          <p>For contractual or legal questions, contact: <a href="mailto:support@neuronworks.co.id" className="text-blue-400 hover:underline">support@neuronworks.co.id</a></p>
          <p>PT Neuronworks Indonesia</p>

        </motion.div>
      </div>
    </div>
  );
};

export default TermsPage;
